/* ---------- in-page anchors ----------
   The header is sticky, so a plain jump-link parks the target underneath it and
   the customer lands on a heading they cannot read. Offset by the real measured
   header height rather than a guessed number, and respect the reduced-motion
   setting instead of forcing a smooth scroll on everyone. */
(function(){
  function headerH(){
    var h = document.querySelector('header');
    return h ? h.getBoundingClientRect().height + 14 : 90;
  }
  function jump(el){
    var y = el.getBoundingClientRect().top + window.scrollY - headerH();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({top: y, behavior: reduce ? 'auto' : 'smooth'});
  }

  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if(!a) return;
    var href = a.getAttribute('href') || '';
    var hash = href.slice(href.indexOf('#') + 1);
    if(!hash) return;
    // Only handle links that stay on this page.
    var path = href.split('#')[0];
    if(path && path !== location.pathname && path !== '' && path !== './') return;
    var el = document.getElementById(hash);
    if(!el) return;                       // a real dead link still behaves like one
    e.preventDefault();
    jump(el);
    history.replaceState(null, '', '#' + hash);
  });

  // Arriving with a hash already in the URL, or from another page.
  if(location.hash.length > 1){
    var el = document.getElementById(location.hash.slice(1));
    if(el) setTimeout(function(){ jump(el); }, 60);
  }
})();

/* ---------- deep links into the finder ----------
   The Shop menu points at the finder with ?type=recliner and friends, and
   "See every size" arrives with ?all=1. Landing someone on step 1 after they
   have already told us what they own is a wasted click. */
(function(){
  function start(){
    var q = new URLSearchParams(location.search);

    if(q.get('all') === '1' && typeof window.bhShowAll === 'function'){
      if(typeof window.go === 'function') window.go(3);
      window.bhShowAll();
      return;
    }
    var t = q.get('type');
    if(!t) return;
    var btn = document.querySelector('.type[data-type="' + t.replace(/["\\]/g,'') + '"]');
    if(btn) btn.click();
  }
  // The finder's own script is deferred, so wait for it to have defined things.
  if(document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();
